import { Users } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useApp } from "@/lib/i18n";

const SOURCES = [["meet", "Google Meet"], ["zoom", "Zoom"], ["teams", "Microsoft Teams"], ["inperson", ["Mesyuarat bersemuka", "In-person meetings"]]];
const OUTPUTS = [["pptx", ["Slaid PowerPoint", "PowerPoint decks"]], ["docx", ["Dokumen Word", "Word documents"]], ["xlsx", ["Hamparan Excel / CSV", "Excel / CSV spreadsheets"]], ["pdf", "PDF"]];

const Tile = ({ id, label }) => {
  const { L } = useApp();
  const text = Array.isArray(label) ? L(...label) : label;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} aria-label={text} className="grid h-14 w-14 place-items-center rounded-2xl border border-slate-200 bg-white shadow-sm transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-md sm:h-16 sm:w-16" data-testid={`integration-icon-${id}`}>
          {id === "inperson" ? <Users size={28} className="text-violet-600" /> : <img src={`/brand/${id}.svg`} alt={text} className="h-7 w-7 sm:h-8 sm:w-8" />}
        </span>
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  );
};

export const IntegrationStrip = () => {
  const { L } = useApp();
  return (
    <section className="border-y border-slate-200 bg-white py-14" data-testid="integration-strip">
      <TooltipProvider delayDuration={100}>
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-3 px-4 sm:gap-4">
          {SOURCES.map(([id, label]) => <Tile key={id} id={id} label={label} />)}
          <span className="mx-2 hidden h-px w-14 bg-slate-300 sm:block" />
          <span className="basis-full sm:hidden" />
          {OUTPUTS.map(([id, label]) => <Tile key={id} id={id} label={label} />)}
        </div>
      </TooltipProvider>
      <p className="mx-auto mt-8 max-w-2xl px-4 text-center text-base text-slate-600 sm:text-lg" data-testid="integration-strip-desc">
        {L("MinitAI mencatat mesyuarat bersemuka dan di Google Meet, Zoom atau Microsoft Teams — kemudian menukarkannya kepada slaid, dokumen, hamparan dan PDF.",
          "MinitAI takes notes in person and on Google Meet, Zoom or Microsoft Teams — then turns them into decks, documents, spreadsheets and PDFs.")}
      </p>
    </section>
  );
};
